import * as StringValidation from '../../libs/validation/stringRegex'
import * as Constants from '../../costants'

import { isValidPrivacy } from '../../components/privacy/BasicPrivacy'

import { authFetch } from '../../libs/cookie/Cookie'

import { basePageOneValidation, CONNECTION_ERROR } from '../../components/pagination/PageOneValidation'

import { isNotValidScadenzaPolizza } from '../../libs/validation/dateValidation'

import { UserType } from '../../libs/user/User' 

import { ContractorType } from '../../components/people/contractor/Contractor'

export async function page1Validation (
    contractor: ContractorType,
    altriSinistri: boolean | undefined,
    polizzaAttiva: boolean | undefined,
    scadenzaPolizza: string | undefined,

    printErrorCallBack: Function,
    manageExpiredSessionsCallBack: Function
) {
    return basePageOneValidation (
        contractor,
        altriSinistri,
        polizzaAttiva,
        scadenzaPolizza,
        Constants.STEP_1_VALIDATION_URL,
        printErrorCallBack,
        manageExpiredSessionsCallBack
    )
}

export async function page2Validation (
    altriSinistri: boolean | undefined,
    polizzaAttiva: boolean | undefined,
    scadenzaPolizza: string | undefined,

    soggetti: string | undefined,

    printErrorCallBack: Function,
    manageExpiredSessionsCallBack: Function
) {
    let error = undefined

    if (altriSinistri === undefined) {
        error = 'SINISTRI'
    }
    else if (polizzaAttiva === undefined) {
        error = 'POLIZZA'
    }
    else if (
        polizzaAttiva === true && 
        isNotValidScadenzaPolizza(scadenzaPolizza)
    ) {
        error = 'SCADENZA_POLIZZA'
    }
    else if (StringValidation.isEmpty( soggetti )) {
        error = 'SOGGETTI'
    }
    else {
        await authFetch (
            Constants.STEP_2_VALIDATION_URL,
            {
                method: "post",
                body: JSON.stringify({
                    sinistriPrecedenti: altriSinistri ?? false,
                    polizzaGiaAttiva: polizzaAttiva ?? false,
                    dataScadenza: (polizzaAttiva === true) 
                        ? (scadenzaPolizza ?? null)
                        : null,
                    Health_Insurance_Subjects: soggetti ?? null
                })
            },
            manageExpiredSessionsCallBack,
        ).then ( jsonObj => {
            if (jsonObj.status > 200) {
                error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
            }
        }).catch( error => {
            error = CONNECTION_ERROR
        })
    }

    printErrorCallBack (error)

    return error
}

export async function page3Validation (
    reddito: string | undefined,
    coperture: string | undefined,

    printErrorCallBack: Function,
    manageExpiredSessionsCallBack: Function
) {
    let error = undefined

    if (StringValidation.isEmpty( reddito )) {
        error = 'REDDITO'
    }
    else if (StringValidation.isEmpty( coperture ) ) {
        error = 'COPERTURE'
    }
    else {
        await authFetch (
            Constants.STEP_3_VALIDATION_URL,
            {
                method: "post",
                body: JSON.stringify({
                    Household_Income: reddito ?? null,
                    Health_Most_Important_Coverage_Reasons: coperture ?? null
                })
            },
            manageExpiredSessionsCallBack,
        ).then ( jsonObj => {
            if (jsonObj.status > 200) {
                error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
            }
        }).catch( error => {
            error = CONNECTION_ERROR
        })
    }

    printErrorCallBack (error)

    return error
}

export async function page4Validation (
    situazioni: string | undefined,

    printErrorCallBack: Function,
    manageExpiredSessionsCallBack: Function
) {
    let error = undefined

    if (StringValidation.isEmpty( situazioni )) {
        error = 'SITUAZIONI'
    }
    else {
        await authFetch (
            Constants.STEP_4_VALIDATION_URL,
            {
                method: "post",
                body: JSON.stringify({
                    Health_Insurance_Diseases: situazioni ?? null
                })
            },
            manageExpiredSessionsCallBack,
        ).then ( jsonObj => {
            if (jsonObj.status > 200) {
                error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
            }
        }).catch( error => {
            error = CONNECTION_ERROR
        })
    }

    printErrorCallBack (error)

    return error
}

export async function page5Validation (
    patologie: string | undefined,
    noMotorPrivacy: any,
    user: UserType | undefined,

    printErrorCallBack: Function,
    manageExpiredSessionsCallBack: Function
) {
    let error = undefined

    if (StringValidation.isEmpty( patologie )) {
        error = 'PATOLOGIE'
    }
    else if (isValidPrivacy( noMotorPrivacy, user !== undefined)) {
        error = 'PRIVACY'
    }
    else {
        await authFetch (
            Constants.STEP_5_VALIDATION_URL,
            {
                method: "post",
                body: JSON.stringify({
                    Health_Insurance_Specific_Diseases: patologie ?? null,
                    privacy: noMotorPrivacy ?? null,
                    isLoggedUser: (user !== undefined)
                })
            },
            manageExpiredSessionsCallBack,
        ).then ( jsonObj => {
            if (jsonObj.status > 200) {
                error = jsonObj.msg ?? "Impossibile salvare la richiesta, riporva più tardi."
            }
        }).catch( error => {
            error = CONNECTION_ERROR
        })
    }

    printErrorCallBack (error)

    return error
}